import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
  timeout: 15000,
});

API.interceptors.request.use(config => {
  const token = localStorage.getItem('wh_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

API.interceptors.response.use(
  r => r,
  err => {
    if (err.response?.status === 401 || err.response?.status === 403) {
      const msg = err.response?.data?.error || '';
      if (msg.includes('expired') || msg.includes('Invalid')) {
        localStorage.clear();
        window.location.href = '/';
      }
    }
    return Promise.reject(err);
  }
);

export const authAPI = {
  login: (u, p) => API.post('/api/auth/login', { username: u, password: p }),
};

export const scanAPI = {
  receive:       (lrNumber, barcodes, total)  => API.post('/api/scan/receive', { lrNumber, barcodes, totalInLR: total }),
  validate:      (barcode)                    => API.get(`/api/scan/validate/${barcode}`),
  // QC: select decision first, then submit whole batch
  qcBatch:       (barcodes, decision)         => API.post('/api/scan/qc', { barcodes, decision }),
  // Partners scan refinish items — partner auto-detected from login
  partner:       (barcode, grade)             => API.post('/api/scan/partner', { barcode, grade }),
  partnerReturn: (barcode)                    => API.post('/api/scan/return', { barcode }),
  getBarcode:    (code)                       => API.get(`/api/scan/barcode/${code}`),
  getStats:      ()                           => API.get('/api/scan/stats'),
  exportExcel:   (lr)                         => API.get(`/api/scan/export${lr ? '?lr=' + lr : ''}`, { responseType: 'arraybuffer' }),
};

export default API;
